import React, { Component } from 'react'
import { checkTranslation, getObject } from '../utils/useful';
import HttpServices from '../utils/Http.services';
import * as actions from '../stores/actionsList';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import inputComponents from '../components/inputs/inputComponents';
import tableComponents from '../components/tableComponents'
import Collapsible from 'react-collapsible';
import TextAreaInput from '../components/inputs/TextAreaInput';



class History extends Component {

    state = {
        histories: [],
        active: 0,
        limit: 20,
        currentPage: 0,
        opened: null,
        collapses: [],
        filter: {},
        headers: [
            { type: 'TextInput', key: 'title', col: '6', information: { label: '{{lang}}title', placeholder: '{{lang}}title', required: true } },
            { key: 'thing', type: 'SelectInput', col: '6', information: { label: '{{lang}}Thing', address: 'getMyThings', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Thing', required: true }, showMain: true },
            { key: 'applet', type: 'SelectInput', col: '6', information: { label: '{{lang}}Applet', address: 'getMyApplets', filter: {}, fields: { title: 'aTarget.name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Applet', required: true }, showMain: true },
            { type: 'SelectInput', key: 'refType', information: { label: '{{lang}}useful.type', type: 'local', items: [{ value: 'applet', title: 'Applet' }, { value: 'thing', title: 'Thing' }, { value: 'dashboard', title: 'Dashboard' }], placeholder: '{{lang}}placeholders.insertType', required: true } },

            { type: 'DateInput', key: 'cDate', hideComponent: true, information: { label: '{{lang}}Create date', placeholder: '{{lang}}Create date', required: false, hideComponent: true } },

            // { key: 'body', type: 'EditorInput', col: '12', information: { label: '{{lang}}Body', placeholder: '{{lang}}body', required: true, inputClass: 'null' }, showMain: false },
            // { key: 'attachments', type: 'FileInput', col: '12', information: { label: '{{lang}}Attachments', placeholder: '{{lang}}Attachments', required: false, inputClass: 'null' }, showMain: false },

        ],
        historyInfo: [
            { col: '6', key: 'title', type: 'TextInput', information: { label: '{{lang}}Title', disabled: true }, showMain: true, inExport: true },
            { col: '6', key: 'stage', type: 'TextInput', information: { label: '{{lang}}Status', disabled: true }, showMain: true, inExport: true },
            { col: '6', key: 'uDate', type: 'DateInput', information: { label: '{{lang}}Last modified date', disabled: true }, showMain: true, inExport: true },
            { col: '6', key: 'originnoncompliance', type: 'TextInput', information: { label: '{{lang}}Non-compliance origin', disabled: true }, showMain: true, inExport: true },
            { col: '6', key: 'processes', type: 'TextInput', information: { label: '{{lang}}Process', disabled: true }, showMain: true, inExport: true },
            { col: '6', key: 'department', type: 'TextInput', information: { label: '{{lang}}Department', disabled: true }, showMain: true, inExport: true },
            { col: '6', key: 'requirementTypes', type: 'TextInput', information: { label: '{{lang}}Requirement type', disabled: true }, showMain: true, inExport: true },
            { col: '6', key: 'trackingcode', type: 'TextInput', information: { label: '{{lang}}Tracking Code', disabled: true }, showMain: true, inExport: true },
            { col: '12', key: 'requirementDescription', type: 'TextInput', information: { label: '{{lang}}Requirement description', disabled: true }, showMain: true, inExport: true },
            { col: '12', key: 'evidenceProblems', type: 'TextInput', information: { label: '{{lang}}Forms and evidence', disabled: true }, showMain: true, inExport: true },
            { col: '12', key: 'attachment', type: 'FileInput', information: { label: '{{lang}}Attachments', disabled: true }, showMain: true, inExport: true },
        ],
        // historyInfo: [
        //     { name: '{{lang}}Non-compliance title', value: '{{lang}}Test' },
        //     { name: '{{lang}}Requirement type', value: '{{lang}}Test' },
        //     { name: '{{lang}}Process', value: '{{lang}}Test' },
        //     { name: '{{lang}}Standard source', value: '{{lang}}Test' },
        //     { name: '{{lang}}Registrant', value: 'ادمین' },
        //     { name: '{{lang}}Registration date', value: '2023/09/30' },
        // ],

        Tab: [

            { name: "{{lang}}All", number: "0" },
            { name: "{{lang}}Unseen", number: "0" },

        ]
    }
    componentDidMount() {
        this.init()
    }

    componentDidUpdate(prevProps) {
        if (prevProps.headers != this.props.headers && this.props.page && this.props.page.pageType == 'history') {
            this.init()

        }
    }

    changeCollapse = (index) => {
        let collapses = this.state.collapses
        // console.log('befCollapse', [...collapses])
        collapses[index] = this.state.collapses[index] == null ? true : !this.state.collapses[index]
        // console.log('afterCollapse', [...collapses])
        this.setState({ collapses })
    }

    init = () => {
        let search = window.location.search;
        console.log('searchis ', search)
        let params = new URLSearchParams(search);
        let id = params.get('id');
        HttpServices.request('getHistory', { id }, (fetchResult, fetchError) => {
            if (fetchError) {
                return
            }
            console.log('fetchResulttt', JSON.parse(JSON.stringify(fetchResult)))
            this.normalizeData(fetchResult.info)
            this.setState({ histories: fetchResult.info })
        })
    }
    normalizeData = (data) => {
        data.map((element, index) => {
            if (element.lastStage && element.lastStage != 'null') {
                switch (element.lastStage) {
                    case 'initialReview':
                        // console.log('data[index].info.needEdit', data[index].info.needEdit)
                        // data[index].info.needEdit = { key: 'needEdit', label: 'اصلاح نیاز دارد؟', value: JSON.parse(JSON.stringify(data[index].info.needEdit)), input: 'SelectInput' }
                        console.log('data[index].info.DateRootting', data[index].info.DateRootting)
                        data[index].info = {
                            needEdit: { key: 'needEdit', label: '{{lang}}Need correction?', value: data[index].info.needEdit, input: 'SelectInput', header: { key: 'needEdit', information: { label: '{{lang}}Need correction?', type: 'local', items: [{ title: "{{lang}}No", value: false }, { title: '{{lang}}Yes', value: true }], icon: '/images/icons/form.svg', placeholder: '{{lang}}Need correction?', required: true, disabled: true } } },
                            inCharge: { key: 'inCharge', label: '{{lang}}Incharge person', value: data[index].info.inCharge, input: 'SelectInput', header: { key: 'inCharge', showKey: 'title', information: { label: '{{lang}}Incharge person', address: 'getAllUser', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Select a value', required: false, disabled: true } } },
                            dateDone: { key: 'dateDone', label: '{{lang}}Due date', value: data[index].info.dateDone, input: 'DateInput', header: { key: 'dateDone', information: { label: '{{lang}}Due date', required: false, disabled: true } } },
                            actionandEdit: { key: 'actionandEdit', label: '{{lang}}Need corrective action?', value: data[index].info.actionandEdit, input: 'SelectInput', header: { key: 'needEdit', information: { label: '{{lang}}Need corrective action?', type: 'local', items: [{ title: '{{lang}}No', value: false }, { title: '{{lang}}Yes', value: true }], icon: '/images/icons/form.svg', placeholder: '{{lang}}Corrective action is required', required: true, disabled: true } } },
                            DateRootting: { key: 'DateRootting', label: '{{lang}}Rooting deadline', value: data[index].info.DateRootting, input: 'DateInput', header: { key: 'DateRootting', information: { label: '{{lang}}Rooting deadline', address: 'getAllUser', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, required: true, disabled: true }, showMain: false, dependencies: [{ refKey: 'actionandEdit', targetKey: 'DateRootting', conditions: { root: { id: 'root', action: 'or', conditions: { 1: { id: 1, source: { value: '@data.actionandEdit' }, operator: { value: '==' }, target: { value: "true" } }, } }, }, show: true, init: true, changeHeader: { key: 'information.required', value: false }, }], } },
                            DatePlanning: { key: 'DatePlanning', label: '{{lang}}Planning deadline', value: data[index].info.DatePlanning, input: 'DateInput', header: { key: 'DatePlanning', information: { label: '{{lang}}Planning deadline', address: 'getAllUser', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, required: true, disabled: true }, showMain: false, dependencies: [{ refKey: 'actionandEdit', targetKey: 'DatePlanning', conditions: { root: { id: 'root', action: 'or', conditions: { 1: { id: 1, source: { value: '@data.actionandEdit' }, operator: { value: '==' }, target: { value: "true" } }, 1: { id: 1, source: { value: '@data.actionandEdit' }, operator: { value: '==' }, target: { value: true } }, } }, }, show: true, init: true, changeHeader: { key: 'information.required', value: false }, }], } },
                            description: { key: 'description', label: '{{lang}}Description', value: data[index].info.description, input: 'TextInput', header: { key: 'description', information: { label: '{{lang}}Description', address: 'getAllUser', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Select a value', required: true, disabled: true } } },
                            descriptionAction: { key: 'descriptionAction', label: '{{lang}}Action description', value: data[index].info.descriptionAction, header: { key: 'descriptionAction', information: { label: '{{lang}}Action description', placeholder: '{{lang}}Description', required: false, disabled: true } }, input: 'TextAreaInput', manualInput: true },

                        }
                        break;

                    case 'correction':
                        console.log('data[index].info', data[index].info)
                        console.log('inputTableComponents', tableComponents)
                        data[index].info = {
                            correctivdescription: { key: 'correctivdescription', label: '{{lang}}Modification description', value: data[index].info.correctivdescription, input: 'TextInput', header: { key: 'correctivdescription', information: { label: '{{lang}}Modification description', required: true, disabled: true } } },
                            correctivattachment: { key: 'correctivattachment', label: '{{lang}}Modification attachment', value: data[index].info.correctivattachment, tableComponent: true, input: 'FileInput', header: { key: 'correctivattachment', information: { label: '{{lang}}Modification attachment', disabled: true }, } },
                        }
                        break;

                    case 'userRootting':
                        data[index].info = {
                            correctivdescription: { key: 'correctivdescription', label: '{{lang}}Modification description', value: data[index].info.correctivdescription, input: 'TextInput', header: { key: 'correctivdescription', information: { label: '{{lang}}Suggestion and solution', placeholder: '{{lang}}Suggestion and solution', required: false, disabled: true } } },
                            correctivattachment: { key: 'correctivattachment', label: '{{lang}}Modification attachment', value: data[index].info.correctivattachment, tableComponent: true, input: 'FileInput', header: { key: 'correctivattachment', information: { label: '{{lang}}Review description', placeholder: '{{lang}}Review description', required: false, disabled: true } } },

                        }
                        break;
                    case 'conclusion':
                        data[index].info = {
                            correctivdescription: { key: 'correctivdescription', label: '{{lang}}Modification description', value: data[index].info.correctivdescription, input: 'TextInput', header: { key: 'correctivdescription', information: { label: '{{lang}}Suggestion and solution', placeholder: '{{lang}}Suggestion and solution', required: false, disabled: true } } },
                            correctivattachment: { key: 'correctivattachment', label: '{{lang}}Modification attachment', value: data[index].info.correctivattachment, tableComponent: true, input: 'FileInput', header: { key: 'correctivattachment', information: { label: '{{lang}}Review description', placeholder: '{{lang}}Review description', required: false, disabled: true } } },

                        }
                        break;
                    case 'userPlanning':
                        data[index].info = {
                            inCharge: { key: 'inCharge', label: '{{lang}}Incharge person', value: data[index].info.inCharge, header: { key: 'inCharge', information: { address: 'getAllUser', filter: {}, fields: { title: 'name', post: 'name', value: '_id' }, type: 'api', label: '{{lang}}Incharge person', placeholder: '{{lang}}Incharge person', required: true, disabled: true } }, input: 'SelectInput' },
                            dateDone: { key: 'dateDone', label: '{{lang}}Deadline', value: data[index].info.dateDone, header: { key: 'dateDone', information: { label: '{{lang}}Deadline', placeholder: '{{lang}}Deadline', required: true, disabled: true } }, input: 'DateInput' },
                            importantdeg: { key: 'importantdeg', label: '{{lang}}Importance degree', value: data[index].info.importantdeg, header: { key: 'importantdeg', information: { label: '{{lang}}Importance degree', placeholder: '{{lang}}Importance degree', required: true, disabled: true } }, input: 'NumberInput' },
                            descriptionAction: { key: 'descriptionAction', label: '{{lang}}Action description', value: data[index].info.descriptionAction, header: { key: 'descriptionAction', information: { label: '{{lang}}Action description', placeholder: '{{lang}}Action description', required: false, disabled: true } }, input: 'TextAreaInput', manualInput: true },

                        }
                        break;

                    default:
                        break;
                }
            }
            else if (element.action != 'stageUpdate') {
                if (element.planningId && element.dependency == true && element.action != 'create') {
                    data[index].info = {
                        description: { key: 'description', label: '{{lang}}Description', value: data[index].info.description, header: { key: 'description', type: 'TextAreaInput', information: { label: '{{lang}}Description' }, showMain: true, inExport: true }, input: 'TextAreaInput', edit: element.action == 'editForm' ? true : false },

                    }
                }
                else if (element.planningId && !element.dependency && element.action != 'create') {

                }
                else {

                }
            }
        })
        this.setState({ histories: data })
    }
    translateStage = (stage) => {
        let translatedStage
        switch (stage) {
            case 'initialReview':
                translatedStage = '{{lang}}Initial inspection'
                break;

            case 'userRootting':
                translatedStage = '{{lang}}Rootting'
                break;

            case 'userPlanning':
                translatedStage = '{{lang}}Planning'
                break;

            case 'conclusion':
                translatedStage = '{{lang}}Conclusioning'
                break;

            case 'userEffectiveness':
                translatedStage = '{{lang}}Effectiveness'
                break;

            case 'recordResult':
                translatedStage = '{{lang}}Result record'
                break;

            case 'correction':
                translatedStage = '{{lang}}Correction'
                break;

            case 'done':
                translatedStage = '{{lang}}Terminated'
                break;

            case 'Done':
                translatedStage = '{{lang}}Terminated'
                break;

            case 'reject':
                translatedStage = '{{lang}}Rejected'
                break;

            default:
                translatedStage = stage
                break;
        }
        return translatedStage
    }
    showManualInput = (info) => {

        switch (info.input) {
            case 'TextAreaInput': {
                console.log('infoooman', info)
                console.log('infooomanValue', info.value)

                return (
                    <div className='flex flex-column'>
                        <p className='pl-2 mb-2' style={{ whiteSpace: 'nowrap' }}>{checkTranslation(info.label)}</p>
                        <div className='modern-input'>
                            <TextAreaInput data={info.value} header={{ information: { disabled: true } }} />
                        </div>
                    </div>
                )
            }

            default:
                break;
        }
    }
    render() {
        return (
            <div className='w-100 ' style={{}}>
                <div className='w-100' style={{ backgroundColor: '#F87C56' }}>
                    {this.state.histories.map((prop, index) => {
                        if (prop.action == 'create') {
                            return (
                                <div className='row m-0 p-4 w-100'>
                                    {this.state.historyInfo.map((header) => {
                                        let value = getObject(prop.info, header.key)
                                        let Component = tableComponents[header.type]
                                        if (header.key == 'stage') {
                                            value = this.translateStage(value)
                                        }
                                        if (header.key == 'attachment') {
                                            if (typeof prop.info.attachment == 'string') {

                                                prop.info.attachment = JSON.parse(prop.info.attachment)
                                            }
                                            value = getObject(prop.info, header.key)
                                        }
                                        return (
                                            <div className="col-4 p-2 w-100" >
                                                <div className=" w-100 mb-3" >
                                                    <p className='mb-2' style={{ whiteSpace: 'nowrap', fontSize: 13, color: 'white' }}>{checkTranslation(header.information?.label)} :&nbsp;</p>
                                                    <div className=' p-2' style={{ backgroundColor: 'rgba(255, 255, 255, 0.9)', borderRadius: 10 }}>
                                                        {Component && (
                                                            <Component data={value} header={header} />
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            )
                        }
                    })}
                </div>
                {/* <div className='row m-0 p-4' style={{ backgroundColor: '#F87C56' }}>
                    <FormViewer ref={el => this.form = el} initData={this.props.initData} variables={this.props.variables} headers={this.state.historyInfo} />
                </div> */}
                <div className='p-4'>
                    {this.state.histories.map((element, index) => {
                        return (
                            <div>
                                {element.lastStage != 'null' && (
                                    <button className='p-3 mb-2 flexcb w-100 ' style={{ backgroundColor: '#e9eff6', borderRadius: '15px' }} onClick={() => this.changeCollapse(index)}>
                                        <p>{checkTranslation(this.translateStage(element.lastStage))}</p>
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="#222" class="" style={{ width: 18, transform: this.state.collapses[index] ? 'rotate(-270deg)' : 'rotate(-90deg)', transition: "0.3 all" }}>
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
                                        </svg>
                                    </button>
                                )}
                                <Collapsible open={!this.state.collapses[index]} transitionTime={500}>
                                    <div className='row m-0'>
                                        {Object.values(element.info).map((info) => {
                                            if (typeof info == 'object') {

                                                if (info?.manualInput) {
                                                    return (
                                                        <div className='col-12'>
                                                            <div className='p-3'>
                                                                <p>{checkTranslation(this.showManualInput(info))}</p>
                                                            </div>
                                                        </div>
                                                    )

                                                }
                                                else {

                                                    let Component
                                                    if (info?.input && !info.tableComponent) {
                                                        Component = inputComponents[info.input]
                                                    }
                                                    else if (info?.input && info.tableComponent) {
                                                        Component = tableComponents[info.input]
                                                    }
                                                    return (
                                                        <div className='col-6'>
                                                            {info?.label && (
                                                                <div className='flex flex-column p-3' style={{ cursor: 'pointer' }}>
                                                                    <p className='pl-2 mb-2' style={{ whiteSpace: 'nowrap' }}>{checkTranslation(info.label)}</p>
                                                                    {info?.input && (
                                                                        <div className='modern-input'>
                                                                            <Component data={info.value} header={info.header} />
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            )}
                                                        </div>
                                                    )
                                                }
                                            }
                                        })}
                                    </div>
                                </Collapsible>

                            </div>
                        )
                    })}
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({ settings: state.settings, cart: state.cart, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(History);
